/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";

import { ClientsDataConnector } from "../../api/clientsDataConnector";
import { clientsActions } from "./clientsSlice";
import { setUserRole } from "../user/userSlice";
import type {
  ClientsResponse,
  GetClientsByPlatformRequest,
  RoleContextResponse,
} from "./clientsTypes";
import type { UserRole } from "../user/userTypes";

function* getClientsByPlatformWorker(
  _action: PayloadAction<GetClientsByPlatformRequest>,
) {
  try {
    const dc = new ClientsDataConnector();

    const response: RoleContextResponse = yield call(
      [dc, dc.getClientsByPlatform as any],
    );

    const data: ClientsResponse = Array.isArray(response?.TBData)
      ? response.TBData
      : [];
    const role = (response?.permissionResult?.templateResource as UserRole) || "TB_GENERAL_READONLY";

    yield put(setUserRole({ role }));
    yield put(clientsActions.getClientsByPlatformSucceeded({ data }));
  } catch (error) {
    const message =
      (error as { response?: { data?: { message?: string } }; message?: string })?.response?.data?.message ||
      (error as { message?: string })?.message ||
      "Failed to fetch client numbers";

    yield put(setUserRole({ role: "TB_GENERAL_READONLY" }));
    yield put(clientsActions.getClientsByPlatformFailed({ error: message }));
  }
}

export function* clientsSaga() {
  yield takeLatest(
    clientsActions.getClientsByPlatformRequested.type,
    getClientsByPlatformWorker,
  );
}
